import { COLORS, pickThemeFontStyles } from '@/theme';
import { Upload } from 'antd';
import { styled } from 'styled-components';

const { Dragger } = Upload;

export const StyledFileUpload = styled(Dragger)`
  .ant-upload.ant-upload-drag {
    background-color: ${COLORS.COLOR_SEARCH};
    border: 1px solid ${COLORS.GRAY_LIGHTER};

    .ant-upload-drag-container {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 1rem;
    }

    .ant-upload-btn {
      display: block;
      overflow: hidden;
    }
  }
`;

export const StyledBlock = styled.div`
  display: flex;
  flex-direction: column;
`;

export const StyledInfo = styled.p`
  margin: 0;
  ${pickThemeFontStyles('12', '26')};
  color: ${COLORS.TEXT_HINT};
`;

export const StyledButtons = styled.div`
  display: flex;
  gap: 1rem;
`;

export const StyledFileName = styled.p`
  font-size: 1rem;
  margin: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
